import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';
import UpgradeModal from './UpgradeModal';
import api from '../api/client';

const TierGateContext = createContext(null);

/**
 * Provider that intercepts `tier_required` API responses and shows the upgrade modal.
 * Wrap your app with this inside AuthProvider.
 */
export function TierGateProvider({ children, currentTier = 'FREE' }) {
  const [gateInfo, setGateInfo] = useState(null);

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      (response) => response,
      (error) => {
        const data = error.response?.data;
        if (data?.error === 'tier_required') {
          setGateInfo({
            feature: data.feature,
            required: data.required?.toUpperCase(),
            current: data.current?.toUpperCase(),
          });
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(interceptor);
    };
  }, []);

  const closeModal = useCallback(() => setGateInfo(null), []);

  return (
    <TierGateContext.Provider value={{ setGateInfo }}>
      {children}
      <UpgradeModal
        isOpen={!!gateInfo}
        onClose={closeModal}
        feature={gateInfo?.feature}
        requiredTier={gateInfo?.required || 'BASIC'}
        currentTier={gateInfo?.current || currentTier}
      />
    </TierGateContext.Provider>
  );
}

export function useTierGate() {
  return useContext(TierGateContext);
}
